import { Component, Prop, State, h, Watch, Fragment, Event, Listen, EventEmitter } from '@stencil/core';
import ChatSDK from 'test-iso-chat-sdk';
// import { CHAT_CREDS, MQTT_CREDS, leOfferChatCreds } from '../../../constants/chat-creds';
// import client from '../../../utils/chatSdk';
import { getDeviceID, getGroupcastUrlQuery } from '../../../lib/helpers';
import { selectChatPlaceholderSvg } from '../../../assets/svg/SelectChatPlaceholder.js';
import '../../../stories/Components/Loader/Spinner/Spinner';
import { getConversationEligibleMembers, removeConversationMember } from '../../../api/group-members.js';
import { showToast } from '../../../stories/Components/Toaster/toast-helper';
import '../../ChatUIComponent/ChatOwnProfile/Profile';
import '../../../stories/Components/ProfileSidebar/ProfileSidebar';
import '../../../stories/Components/ContactInfo/ContactInfo';
import './WebchatRightSide';
import '../../../stories/Components/MainPlaceHolder/MainChatPlaceHolder';
import { unreadCountStore } from '../../../store/unread-count';
import { groupMembersStore } from '../../../store/group-members';
import { WEB_CONTENT } from '../../../constants/content';
import { getGroupcast, getGroupcastMessage, getGroupcastMembers, removeGroupcastMember } from '../../../api/groupcast.js';
import { drawerDialogService } from '../../../stories/Components/Dialog-Drawer/dialog-drawer.js';
import { getTotalUnreadConversationsCount } from '../../../api/conversations';
@Component({
  tag: 'web-chat',
  shadow: true,
  styleUrl: 'web-chat.css',
})
export class WebChat {
  @Prop() name: string;
  @Prop() baseUrl: string;
  @Prop() licenseKey: string;
  @Prop() appSecret: string;
  @Prop() userSecret: string;
  @Prop() userToken: string;
  @Prop() themeUrl: string;
  @Prop() defaultTheme: string;
  @Prop() isometrikUserId: string;
  @Prop() projectId: string;
  @Prop() keysetId: string;
  @Prop() accountId: string;
  @Prop() conversationId: string;
  @Prop() hostUrl?: string;
  // @Prop() leofferAccountId?: string = '6863975e4012fddfa1c6d6a7'; //adithyan accountid
  @Prop() leofferAccountId?: string;
  @Prop() groupcastEnabled?: boolean;
  @Prop() getPaymentsData?: Function;
  @Prop() containerId: string;
  @Prop() handleBackButtonClick?: Function;

  @State() unreadConversations: any = [];
  @State() allLinks: any;
  @State() allLinksCount: any;
  @State() isInitialized: boolean = false;
  @State() findUserId: any = {};
  @State() mqttClient: any = null;
  @State() mqttInitialized: boolean = false;
  @State() isMqttConnected: boolean = false;
  @State() allMessages: any = [];
  @State() selectConversationMessages: any = [];
  @State() userMetaData: any = null;
  @State() allConversationList: any = [];
  @State() conversationMetaData: any = {};
  @State() selctConversationMetaData: any = {};
  @State() isMessageLimitEnd: boolean = false;
  @State() skip: number = 0;
  @State() isMessagesLoading: boolean = false;
  @State() isMessageSending: boolean = false;
  @State() deviceId: string = '';
  @State() isScrollToBottom: boolean = true;
  @State() isScrollToTop: boolean = false;
  @State() isConversationLoading: boolean = false;
  @State() isLoadingConversationList: boolean = false;
  @State() unreadConversationsCount: number = 0;
  @State() isChatClosed: boolean = false;
  @State() isChatMinimized: boolean = false;
  @State() isSubscribedToTopic: boolean = false;
  @State() isMessageListenerAttached: boolean = false;
  @State() isInitialCallDone: boolean = false;
  @State() isTyping: boolean = false;
  @State() typingUserName: string = '';
  @State() selectedConversationId: string | null = null;
  @State() unreadMessageCount: number = 0;
  @State() unreadMessageCountFromApi: any = null;
  @State() isLoading: boolean = true;
  @State() loadingProgress: number = 0;
  @State() loadingStatus: string = 'Initializing...';
  @State() isLoadingMessage: boolean = false;
  @State() hasMoreConversations: boolean = false;
  @State() eligibleMembers: any[] = [];
  @State() membersListSkip: number = 0;
  @State() hasMoreEligibleMembers: boolean = true;
  @Event() unreadMessageCountUpdated: EventEmitter;
  @Event() conversationNotFound: EventEmitter;
  @State() isMobileView: boolean = false;
  @State() showSidebar: boolean = false;
  @State() isContactInfoOpen: boolean = false;
  @State() isProfileInfoOpen: boolean = false;
  @State() isOpenSearchBar: boolean = false;
  @Prop() isChatFilter: boolean = false;
  @Prop() isAllChatButton: boolean = true;
  @Prop() isSidebarHeaderLabel: boolean = true;
  @Prop() sidebarHeaderLabel: string = 'Inbox';
  @Prop() isSidebarHeaderSearch: boolean = true;
  @Prop() sidebarColor: string = 'var(--bg-primary-color)';
  @Prop() sidebarSelectedColor: string = '#9566D54D';

  // Smart preloading for infinite scroll with filtering
  @State() conversationCountSkip: number = 0;
  @State() isPreloadingForFilter: boolean = false;
  @State() minConversationsForScroll: number = 50; // Minimum conversations needed for proper infinite scroll
  @State() currentFilteredCount: number = 0;
  @State() lastActiveTab: string = 'all';
  @State() hasReachedEndOfConversations: boolean = false;
  @State() messageSearchText: string = '';
  @State() searchedMessageDetails: any = [];
  @State() initialConversationIdFromURL: string = '';
  @State() allAttachments: any = [];
  @State() selectConverSationAttachments: any = [];
  @State() highlightedMessageId: string | null = null;
  @State() isBuyer: boolean = false;  @State() messageAction: { action: string; initiator: boolean } = { action: '', initiator: false };
  @State() replyMessage: any = null;
  @State() loadingMediaGallery: boolean = false;
  @State() activeTab: string = 'Chat';
  @State() showRightSideBar: boolean = false;
  @State() conversationIdFromContactinfo: string = '';
  private chatBodyRef: HTMLWebChatBodyElement | null = null;
  private conversationDetailsInterval: NodeJS.Timeout | null = null;
  @State() exitedGroupIds: Set<string> = new Set();
  @State() typingConversationId: string = null;
  @Event() messageReadStatusUpdated: EventEmitter;
  @Event() conversationDetailsUpdated: EventEmitter;
  @State() newMessageNotification: { messageId: string; count: number; conversationId: string } | null = null;
  @State() isBlocked: boolean | string = null;
  @State() allGroupCastContacts: any = [];
  @Prop() toggleTheme: () => void;
  @State() groupcastSkip: number = 0;
  @State() isLoadingMoreGroupcast: boolean = false;
  @State() hasMoreGroupcast: boolean = true;
  @State() groupcastMembers: any = [];

  handleReplyMessage = (e: CustomEvent) => {
    this.replyMessage = e.detail;
  };

  handleremoveReplyMessage = () => {
    this.replyMessage = null;
  };

  handleMessageSearchTextChange = (e: CustomEvent<string>) => {
    this.messageSearchText = e.detail;
  };

  @Watch('selectedConversationId')
  async handleConversationChange() {
    this.replyMessage = null;
    this.isBlocked = null;
    this.conversationMetaData = null; // Set to null instead of empty object
    this.allAttachments = [];
  }
  getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  // Retrieve userToken from cookies
  userTokenFromCookie = this.getCookie('userToken');
  isometrikUserIdFromCookie = this.getCookie('isometrikUserId');
  checkMobileView() {
    this.isMobileView = window.innerWidth <= 768;
  }
  componentWillLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    const isGroupcast = urlParams.has('groupcast');
    const conversationId = urlParams.get('conversation');
    const groupcastId = urlParams.get('groupcast');
    this.initialConversationIdFromURL = isGroupcast ? groupcastId : conversationId;
    this.isMobileView = window.innerWidth <= 768;
    this.selectedConversationId = isGroupcast ? groupcastId : conversationId;
    if (this.isMobileView && (conversationId || groupcastId)) {
      this.showSidebar = false;
    } else {
      this.showSidebar = true;
    }
  }

  async componentDidLoad() {
    try {
      // Device ID
      // this.loadTheme();
      try {
        this.updateLoading(10, 'Getting device ID...');
        const deviceId = await getDeviceID();
        this.deviceId = deviceId;
      } catch (error) {
        console.error('Error getting device ID:', error);
      }

      // Initialize SDK
      try {
        this.updateLoading(25, 'Initializing chat SDK...');
        // ChatSDK.initializeInstance({
        //   baseUrl: CHAT_CREDS.baseUrl,
        //   licenseKey: leOfferChatCreds.licenseKey,
        //   appSecret: leOfferChatCreds.appSecret,
        //   userSecret: leOfferChatCreds.userSecret,
        //   userToken: leOfferChatCreds.userToken,
        // });

        ChatSDK.initializeInstance({
          baseUrl: this.baseUrl,
          licenseKey: this.licenseKey,
          appSecret: this.appSecret,
          userSecret: this.userSecret,
          userToken: this.userToken,
        });
  
        this.isInitialized = true;
      } catch (sdkError) {
        console.error('ChatSDK failed to initialize', sdkError);
        this.isInitialized = false;
        throw new Error('Failed to initialize chat SDK');
      }

      // MQTT setup
      try {
        this.updateLoading(40, 'Setting up MQTT client...');
        await this.setupMqttClient();
      } catch (mqttError) {
        console.error('MQTT client setup failed:', mqttError);
      }

      // User details
      try {
        this.updateLoading(55, 'Getting user details...');
        await this.getUserDetails();
      } catch (userError) {
        console.error('Failed to get user details:', userError);
      }

      // Conversation details
      if (this.initialConversationIdFromURL) {
        try {
          this.updateLoading(70, 'Loading conversation...');
          this.selectedConversationId = this.initialConversationIdFromURL;
          const urlParams = new URLSearchParams(window.location.search);
          const isGroupCast = urlParams.has('groupcast');

          if (isGroupCast) {
            await this.getGroupCastConversationDetails(this.initialConversationIdFromURL);
            const messages = await getGroupcastMessage( this.initialConversationIdFromURL);
            if(messages?.messages) {
              this.allMessages = messages?.messages.reverse()
            }
          } else {
            await this.getUserConversationDetails();
            await this.getMessages(0);
            await this.getAllAttachments(this.initialConversationIdFromURL);
          }
        } catch (conversationError) {
          console.error('Failed to load conversation details:', conversationError);
        }
      }

      try {
        this.updateLoading(85, 'Checking unread messages...');
        const unreadCount = await getTotalUnreadConversationsCount();
        unreadCountStore.updateTotalUnreadCount(unreadCount);
        this.unreadConversationsCount = unreadCount;

        unreadCountStore.onChange('totalUnreadCount', value => {
          this.unreadConversationsCount = value;
        });
      } catch (unreadError) {
        console.error('Error fetching unread conversations:', unreadError);
        this.unreadConversationsCount = 0;
        unreadCountStore.updateTotalUnreadCount(0);
      }

      // Get all conversations
      try {
        this.updateLoading(95, 'Loading conversations...');
        await this.getConversations();
      } catch (conversationsError) {
        console.error('Failed to load conversations:', conversationsError);
      }

      this.checkMobileView();
      window.addEventListener('resize', this.checkMobileView.bind(this));

      this.updateLoading(100, 'Complete!');
    } catch (error) {
      console.error('Critical initialization error:', error);
    } finally {
      // Short delay to show the 100% state before hiding
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    }
  }

  updateLoading(progress: number, status: string) {
    this.loadingProgress = progress;
    this.loadingStatus = status;
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.checkMobileView.bind(this));
    if (this.conversationDetailsInterval) {
      clearInterval(this.conversationDetailsInterval);
    }
  }

  async setupMqttClient() {
    // let retryToConnect:any = null;
    const deviceID = await getDeviceID();
 
    // const mqttClient = ChatSDK.getInstance().initializeMqtt({
    //   hostUri: MQTT_CREDS.URL || this.hostUrl,
    //   clientId: this.isometrikUserIdFromCookie,
    //   licenseKey: leOfferChatCreds.licenseKey,
    //   projectId: leOfferChatCreds.projectId,
    //   keysetId: leOfferChatCreds.keysetId,
    //   accountId: leOfferChatCreds.accountId,
    //   deviceId: deviceID,
    // });

    //     const mqttClient = ChatSDK.getInstance().initializeMqtt({
    //   hostUri: MQTT_CREDS.URL || this.hostUrl,
    //   clientId: leOfferChatCreds.isometrikUserId,
    //   licenseKey: leOfferChatCreds.licenseKey,
    //   projectId: leOfferChatCreds.projectId,
    //   keysetId: leOfferChatCreds.keySetId,
    //   accountId: leOfferChatCreds.accountId,
    //   deviceId: deviceID,
     
    // });

    const mqttClient = ChatSDK.getInstance().initializeMqtt({
      hostUri: this.hostUrl,
      clientId: this.isometrikUserId,
      licenseKey: this.licenseKey,
      projectId: this.projectId,
      keysetId: this.keysetId,
      accountId: this.accountId,
      deviceId: deviceID,
    });

    this.mqttClient = mqttClient;
    let refetchInterval: NodeJS.Timeout | null = null;

    this.isMqttConnected = false;
    this.mqttClient.client.on('connect', async () => {
      console.log('🔗 MQTT Connected successfully');
      this.mqttInitialized = true;
      this.isMqttConnected = true;
      this.subscribeToMQTT();
      if (refetchInterval) {
        clearInterval(refetchInterval);
        refetchInterval = null;
      }
      if (!this.isInitialCallDone && this.selectedConversationId) {
        await ChatSDK.getInstance().message.putRead({ conversationId: this.selectedConversationId });
        this.refetchMessages();
        this.isInitialCallDone = true;
      }
    });

    this.mqttClient.client.on('disconnect', () => {
      console.log('🔌 MQTT Disconnected');
      this.isMqttConnected = false;
    });

    this.mqttClient.client.on('error', (error: any) => {
      console.error('❌ MQTT connection error:', error);
      this.mqttInitialized = false;
      this.isMqttConnected = false;
      this.isInitialCallDone = true;
      if (!refetchInterval) {
        refetchInterval = setInterval(() => {
          console.log('🔄 MQTT connection failed, refetching messages...');
          this.refetchMessages();
        }, 30000);
      }
    });
  }
  handleChatSelect(param: string | { groupcastId: string }) {
    const conversationId = typeof param === 'string' ? param : param.groupcastId;
    
    // Clear current conversation messages before switching
    this.clearCurrentConversationMessages();
    
    this.selectedConversationId = conversationId;
    this.isProfileInfoOpen = false;
    this.isContactInfoOpen = false;
    this.isOpenSearchBar = false;
    
    // Clear conversation metadata first to prevent showing previous chat data
    this.conversationMetaData = null;
    
    // Get complete conversation details from API
    if (typeof param === 'string') {
      this.getUserConversationDetails(conversationId);
    }
    if (typeof param === 'string') {
      this.getAllAttachments(conversationId);
    }
    const url = new URL(window.location.href);

    url.search = '';

    if (typeof param === 'object') {
      url.searchParams.set('groupcast', param.groupcastId);
      this.activeTab = 'GroupCast'
      this.getGroupCastContacts()
      this.conversationMetaData = null;
    } else {
      if (conversationId) {
        url.searchParams.set('conversation', conversationId);
        if (this.isMobileView) {
          this.showSidebar = false;
        }
      } else {
        url.searchParams.delete('conversation');
        this.showSidebar = true;
      }
    }

    window.history.pushState({}, '', url);

    // Reset unread count for the selected conversation
    this.allConversationList = this.allConversationList.map(conversation => {
      if (conversation.conversationId === conversationId) {
        conversation.unreadMessagesCount = 0;
      }
      return conversation;
    });

    // Emit event to update unread message count in the sidebar with reset data
    this.unreadMessageCountUpdated.emit({
      detail: {
        conversationId: conversationId,
        count: 0,
        updatedConversation: this.allConversationList.find(conv => conv.conversationId === conversationId),
        allConversations: this.allConversationList,
        isReset: true // Flag to indicate this is a reset operation
      },
    });
  }

 

  handleBackButton() {
    this.showSidebar = true;
    this.selectedConversationId = null;

    const url = new URL(window.location.href);
    url.searchParams.delete('conversation');
    window.history.pushState({}, '', url);
  }
  sortConversationsByLatestMessage(conversations: any[]) {
    return [...conversations].sort((a, b) => {
      // Handle empty or invalid messages
      if (
        (a?.lastMessageDetails?.action == 'chatMessageSent' || a?.lastMessageDetails?.action == 'forward') &&
        (a?.lastMessageDetails?.body === '' || a?.lastMessageDetails?.action === 'clearConversation')
      )
        return 1; // Move to bottom
      if (
        (b?.lastMessageDetails?.action == 'chatMessageSent' || b?.lastMessageDetails?.action == 'forward') &&
        (b?.lastMessageDetails?.body === '' || b?.lastMessageDetails?.action === 'clearConversation')
      )
        return -1; // Move to top
      
      // Use sentAt if available, otherwise use updatedAt
      const timestampA = a?.lastMessageDetails?.sentAt || a?.lastMessageDetails?.updatedAt || 0;
      const timestampB = b?.lastMessageDetails?.sentAt || b?.lastMessageDetails?.updatedAt || 0;
      
      // Sort by timestamp (newest first)
      return timestampB - timestampA;
    });
  }
  subscribeToMQTT() {
    const messageTopic = `/${this.accountId}/${this.projectId}/Message/${this.isometrikUserId}`;
    const statusTopic = `/${this.accountId}/${this.projectId}/Status/${this.isometrikUserId}`;
    
    if (!this.isSubscribedToTopic) {
      // Subscribe to Message topic
      this.mqttClient.client.subscribe(messageTopic, (error: any) => {
        if (error) {
          console.error('Failed to subscribe to Message topic:', error);
        } else {
          console.log(`Subscribed to Message topic: ${messageTopic}`);
        }
      });
      
      // Subscribe to Status topic
      this.mqttClient.client.subscribe(statusTopic, (error: any) => {
        if (error) {
          console.error('Failed to subscribe to Status topic:', error);
        } else {
          console.log(`Subscribed to Status topic: ${statusTopic}`);
        }
      });
      
      this.isSubscribedToTopic = true;
    }

    if (!this.isMessageListenerAttached) {
      // Set up the listener for incoming messages
      this.mqttClient.client.on('message', async (topic, message: any) => {
        // Validate that the message is from the expected topic (Message or Status)
        const expectedMessageTopic = `/${this.accountId}/${this.projectId}/Message/${this.isometrikUserId}`;
        const expectedStatusTopic = `/${this.accountId}/${this.projectId}/Status/${this.isometrikUserId}`;
        
        if (topic !== expectedMessageTopic && topic !== expectedStatusTopic) {
          console.warn(`Received message from unexpected topic: ${topic}, expected: ${expectedMessageTopic} or ${expectedStatusTopic}`);
          return; // Ignore messages from unexpected topics
        }
        
        const parsedMessage = JSON.parse(message.toString());
        console.log(`New Incoming message from ${topic}:`, parsedMessage);

        // Additional validation: Check if message has conversationId and if it's relevant
        if (parsedMessage.conversationId) {
          // If we have a selected conversation, only process messages for that conversation
          // or messages that affect conversation list (like new conversations)
          const isRelevantMessage = 
            !this.selectedConversationId || // No specific conversation selected, process all
            parsedMessage.conversationId === this.selectedConversationId || // Message for current conversation
            parsedMessage.action === 'conversationCreated' || // New conversation creation
            parsedMessage.action === 'membersAdd' || // Member additions
            parsedMessage.action === 'membersRemove' || // Member removals
            parsedMessage.action === 'addAdmin' || // Admin changes
            parsedMessage.action === 'removeAdmin' || // Admin changes
            parsedMessage.action === 'userBlockConversation' || // Block events
            parsedMessage.action === 'userUnblockConversation' || // Unblock events
            parsedMessage.action === 'userUnblock' || // Unblock events
            parsedMessage.action === 'deleteConversationLocally' || // Conversation deletion
            parsedMessage.action === 'chatMessageSent' || // Chat messages (for sidebar sorting)
            parsedMessage.action === 'forward' || // Forward messages (for sidebar sorting)
            parsedMessage.action === 'typingEvent' || // Typing indicators
            parsedMessage.action === 'multipleMessagesRead' || // Message read status updates
            parsedMessage.action === 'reactionAdd' || // Message reactions
            parsedMessage.action === 'reactionRemove' || // Message reaction removals
            parsedMessage.action === 'messageDelivered' || // Message delivery status
            parsedMessage.action === 'messageRead' || // Message read status
            parsedMessage.action === 'clearConversation'; // Conversation clearing

          if (!isRelevantMessage) {
            console.log(`Ignoring message for conversation ${parsedMessage.conversationId} as it's not relevant to current context`);
            return;
          }
        }

    
        if (parsedMessage.action === 'conversationCreated' && parsedMessage.conversationDetails) {
          const newConversation = {
            conversationId: parsedMessage.conversationId,
            lastMessageDetails: {
              body: parsedMessage?.body,
              updatedAt: parsedMessage?.conversationDetails?.updatedAt || Date.now(),
              userName: parsedMessage?.senderName,
              userProfileImageUrl: parsedMessage?.senderProfileImageUrl,
              action: parsedMessage?.action,
              isDeliveredToAllMembers: false,
              isReadByAllMembers: false,
              senderId: parsedMessage?.senderId,
              sentAt: parsedMessage?.sentAt || 0,
              members: parsedMessage?.members || [],
              senderName: parsedMessage?.senderName,
              messageId: parsedMessage?.messageId,
            },
            isGroup: parsedMessage.conversationDetails.isGroup,
            conversationTitle: parsedMessage?.conversationTitle,
            conversationImageUrl: parsedMessage?.conversationImageUrl,
            ...parsedMessage?.conversationDetails,
          };
          // Add the new conversation to the list and sort
          this.allConversationList = this.sortConversationsByLatestMessage([newConversation, ...this.allConversationList]);
        }
        if (parsedMessage?.action === '"deleteConversationLocally"') {
          this.allConversationList = this.allConversationList.filter(conversation => conversation.conversationId !== parsedMessage.conversationId);

          if (this.selectedConversationId === parsedMessage.conversationId) {
            this.selectedConversationId = null;
            this.showSidebar = true;

            const url = new URL(window.location.href);
            url.searchParams.delete('conversation');
            window.history.pushState({}, '', url);
          }
        }
        if (parsedMessage?.action === 'forward') {
          this.handleForwardMessage(parsedMessage);
        }

        if (parsedMessage?.action === 'typingEvent' && parsedMessage.userId != this.userMetaData.userId) {
          this.isTyping = true;
          this.typingConversationId = parsedMessage.conversationId;
          this.typingUserName = parsedMessage.userName;
          // Add a timeout to reset the typing status after a few seconds
          setTimeout(() => {
            if (this.typingConversationId === parsedMessage.conversationId) {
              this.isTyping = false;
              this.typingConversationId = null;
              this.typingUserName = '';
            }
          }, 3000); // Reset after 3 seconds
        } else if (parsedMessage?.action !== 'typingEvent') {
          this.isTyping = false;
          this.typingConversationId = null;
          this.typingUserName = '';
        }

        if (parsedMessage?.action === 'multipleMessagesRead' && parsedMessage.userId != this.userMetaData?.userId) {
          // Update messages read status
          this.allMessages = this.allMessages?.map(message =>
            message?.readByAll != true && (message?.senderId || message?.senderInfo?.userId) == this.userMetaData?.userId ? { ...message, readByAll: true } : message,
          );

          // Emit event for message read status update
          this.messageReadStatusUpdated.emit({
            detail: {
              conversationId: parsedMessage.conversationId,
              isRead: true,
              isDelivered: true,
              messageId: parsedMessage.messageId,
            },
          });
        }

        if (parsedMessage?.action == 'messagesDeleteForAll') {
          this.allMessages = this.allMessages.filter((message: any) => message.messageId != parsedMessage.messageIds[0]);
          if (parsedMessage?.userId !== this.userMetaData?.userId) {
            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId && conversation?.lastMessageDetails?.messageId === parsedMessage.messageIds[0]) {
                  const lastMessage = conversation?.lastMessageDetails;
                  return {
                    ...conversation,
                    lastMessageDetails: lastMessage
                      ? {
                          ...lastMessage,
                          body: conversation.isGroup
                            ? `This Message Was Deleted`
                            : `${lastMessage?.senderId === this.userMetaData?.userId ? 'You' : lastMessage?.senderName} have Delete message`,
                          updatedAt: parsedMessage.sentAt || Date.now(),
                          action: parsedMessage.action || '',
                          senderName: parsedMessage?.userName || lastMessage?.senderInfo?.userName,
                          senderId: lastMessage?.userId || lastMessage?.senderInfo?.userId,
                        }
                      : null,
                  };
                }
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    unreadMessagesCount: conversation.unreadMessagesCount - 1,
                  };
                }
                return conversation;
              }),
            );
          }
        }

        if (parsedMessage?.senderId == this.userMetaData?.userId && (parsedMessage?.action == 'chatMessageSent' || parsedMessage?.action == 'forward')) {
          this.changeMessageSendingState(false);
          this.allMessages = this.allMessages.map(message => {
            if (message.messageId == parsedMessage.messageId) {
              return {
                ...parsedMessage,
                mentionedUsers: parsedMessage?.mentionedUsers?.length
                  ? parsedMessage?.mentionedUsers?.map(pmUser => {
                      const matchingUser = message.mentionedUsers.find(mUser => mUser.userId === pmUser.userId);
                      return {
                        ...pmUser,
                        userName: matchingUser ? matchingUser?.userName : undefined,
                      };
                    })
                  : [],
              };
            }
            return message;
          });

          // Update conversation list to move the conversation to top when user sends a message
          this.allConversationList = this.sortConversationsByLatestMessage(
            this.allConversationList.map(conversation => {
              if (conversation.conversationId === parsedMessage.conversationId) {
                return {
                  ...conversation,
                  lastMessageDetails: {
                    ...conversation.lastMessageDetails,
                    body: parsedMessage.body,
                    updatedAt: parsedMessage.sentAt || Date.now(),
                    attachments: parsedMessage?.attachments || [],
                    action: parsedMessage?.action,
                    senderId: parsedMessage.senderId,
                    sentAt: parsedMessage?.sentAt || 0,
                    senderName: parsedMessage?.senderName,
                    messageId: parsedMessage?.messageId,
                  },
                };
              }
              return conversation;
            })
          );

          // Call getUserConversationDetails after chatMessageSent
          await this.getUserConversationDetails(parsedMessage.conversationId);
          
          // Force re-render of header buttons if this is the current conversation
          if (parsedMessage.conversationId === this.selectedConversationId) {
            // Trigger a re-render by updating the conversation metadata
            this.conversationMetaData = { ...this.conversationMetaData };
          }
        }

        if (parsedMessage?.action == 'messageDelivered' && parsedMessage.senderId != this.userMetaData?.userId) {
          this.allMessages = this.allMessages?.map(message => (message?.messageId === parsedMessage?.messageId ? { ...message, deliveredToAll: true } : message));
        }

        if (parsedMessage?.action == 'userBlockConversation' || parsedMessage.action == 'userUnblockConversation' || parsedMessage.action == 'userUnblock') {
          if (parsedMessage.action === 'userBlockConversation') {
            if (parsedMessage.conversationId === this.selectedConversationId) {
              this.conversationMetaData = {
                ...this.conversationMetaData,
                messagingDisabled: true,
                updateBlockStatus: Date.now(),
              };
            }

            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    lastMessageDetails: {
                      ...conversation.lastMessageDetails,
                      body: `${
                        parsedMessage?.initiatorId === this.userMetaData?.userId
                          ? `🚫 You blocked ${parsedMessage?.opponentName}`
                          : `🚫 ${parsedMessage?.initiatorName} blocked you`
                      }`,
                      updatedAt: parsedMessage.sentAt || Date.now(),
                      action: parsedMessage.action || '',
                      initiatorName: parsedMessage?.initiatorName,
                      initiatorId: parsedMessage?.initiatorId,
                      opponentName: parsedMessage?.opponentName,
                    },
                  };
                }
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    unreadMessagesCount: conversation.unreadMessagesCount - 1,
                  };
                }
                return conversation;
              }),
            );
          }
          if (parsedMessage.action == 'userUnblock' || parsedMessage.action === 'userUnblockConversation') {
            if (parsedMessage.conversationId === this.selectedConversationId) {
              this.conversationMetaData = {
                ...this.conversationMetaData,
                messagingDisabled: false,
                updateBlockStatus: Date.now(),
              };
            }
            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    lastMessageDetails: {
                      ...conversation.lastMessageDetails,
                      body: `${
                        parsedMessage?.initiatorId === this.userMetaData?.userId ? `You unblocked ${parsedMessage?.opponentName}` : `${parsedMessage?.initiatorName} unblocked you`
                      }`,
                      updatedAt: parsedMessage.sentAt || Date.now(),
                      action: parsedMessage.action || '',
                      initiatorName: parsedMessage?.initiatorName,
                      initiatorId: parsedMessage?.initiatorId,
                      opponentName: parsedMessage?.opponentName,
                    },
                  };
                }
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    unreadMessagesCount: conversation.unreadMessagesCount - 1,
                  };
                }
                return conversation;
              }),
            );
          }
        }

        if (parsedMessage?.action === 'reactionAdd') {
          this.allMessages = this.allMessages.map(message => {
            if (message.messageId === parsedMessage.messageId) {
              // Create a copy of existing reactions or initialize empty object
              const existingReactions = { ...(message.reactions || {}) };

              // Get existing users array for this reaction type or initialize empty array
              const existingUsers = existingReactions[parsedMessage.reactionType] || [];

              // Check if user already reacted
              const userAlreadyReacted = existingUsers.includes(parsedMessage.userId);

              if (!userAlreadyReacted) {
                // Update reactions to match API structure
                const updateReaction = {
                  ...existingReactions,
                  [parsedMessage.reactionType]: [...existingUsers, parsedMessage.userId],
                };

                return {
                  ...message,
                  reactions: updateReaction,
                };
              }

              return message;
            }
            return message;
          });
        }

        if (parsedMessage?.action === 'reactionRemove') {
          this.allMessages = this.allMessages.map(message => {
            if (message.messageId === parsedMessage.messageId) {
              const updateReaction = {
                ...(message.reactions || {}),
              };

              const updatedUsers = (message.reactions?.[parsedMessage.reactionType]?.users || []).filter(user => user.userId !== parsedMessage.userId);

              if (updatedUsers.length > 0) {
                updateReaction[parsedMessage.reactionType] = {
                  users: updatedUsers,
                };
              } else {
                delete updateReaction[parsedMessage.reactionType];
              }

              return {
                ...message,
                reactions: updateReaction,
              };
            }
            return message;
          });
        }

        if (parsedMessage?.action === 'membersAdd') {
          const conversationExists = this.allConversationList.some(conversation => conversation.conversationId === parsedMessage?.conversationId);
          if (parsedMessage.conversationId === this.selectedConversationId) {
            this.conversationMetaData.members = [
              ...this.conversationMetaData.members,
              ...parsedMessage?.members.map(member => ({
                userId: member.memberId,
                userName: member.memberName,
                userProfileImageUrl: member.memberProfileImageUrl,
                userIdentifier: member.memberIdentifier,
                isAdmin: member.isAdmin || false,
              })),
            ];
          }
          const isCurrentUserAdded = parsedMessage.members?.some(member => member.memberId === this.userMetaData?.userId);

          if (!conversationExists && isCurrentUserAdded) {
            // Create new conversation object for added member
            const newConversation = {
              conversationId: parsedMessage.conversationId,
              isGroup: true,
              conversationTitle: parsedMessage.conversationTitle,
              conversationImageUrl: parsedMessage.conversationImageUrl,
              lastMessageDetails: {
                body: `${parsedMessage?.userName} added you`,
                sentAt: parsedMessage?.sentAt || Date.now(),
                action: 'membersAdd',
                userName: parsedMessage?.userName,
                userProfileImageUrl: parsedMessage?.userProfileImageUrl,
                senderId: parsedMessage?.userId,
                senderName: parsedMessage?.userName,
                memberAdded: parsedMessage?.members?.map(member => member.memberName),
                memberAddedUserId: parsedMessage?.members?.map(member => member.memberId),
              },
              unreadMessagesCount: 1,
              members: parsedMessage.members || [],
            };

            // Add the new conversation to the list and sort
            this.allConversationList = this.sortConversationsByLatestMessage([newConversation, ...this.allConversationList]);

            // Update unread count
            this.unreadMessageCountUpdated.emit({
              detail: {
                conversationId: parsedMessage.conversationId,
                count: 1,
              },
            });
          } else if (conversationExists) {
            // Update existing conversation with new member info
            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    lastMessageDetails: {
                      ...conversation.lastMessageDetails,
                      body: `${parsedMessage?.userName} added ${parsedMessage?.members?.[0]?.memberName}`,
                      sentAt: parsedMessage?.sentAt || Date.now(),
                      action: 'membersAdd',
                      userName: parsedMessage?.userName,
                      userProfileImageUrl: parsedMessage?.userProfileImageUrl,
                      memberAdded: parsedMessage?.members?.map(member => member.memberName),
                      memberAddedUserId: parsedMessage?.members?.map(member => member.memberId),
                      members: [...(conversation.members || []), ...parsedMessage.members],
                    },
                    members: [...(conversation.members || []), ...parsedMessage.members],
                  };
                }
                return conversation;
              }),
            );
          }
        }

        if (parsedMessage?.action === 'membersRemove') {
          const conversationExists = this.allConversationList.some(conversation => conversation.conversationId === parsedMessage?.conversationId);
          if (parsedMessage.conversationId === this.selectedConversationId) {
            this.conversationMetaData.members = this.conversationMetaData?.members?.filter(user => user?.userId !== parsedMessage?.members?.[0]?.memberId);
          }
          if (conversationExists) {
            // Update existing conversation with new member info
            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    lastMessageDetails: {
                      ...conversation.lastMessageDetails,
                      body: `${parsedMessage?.userName} removed ${parsedMessage?.members[0]?.memberName}`,
                      sentAt: parsedMessage?.sentAt || Date.now(),
                      action: 'membersRemove',
                      userName: parsedMessage?.userName,
                      userProfileImageUrl: parsedMessage?.userProfileImageUrl,
                      memberAdded: parsedMessage?.members?.map(member => member.memberName),
                      memberAddedUserId: parsedMessage?.members?.map(member => member.memberId),
                      members: [...(conversation.members || []), ...parsedMessage.members],
                    },
                    members: [...(conversation.members || []), ...parsedMessage.members],
                  };
                }
                return conversation;
              }),
            );
          }
        }
        if (parsedMessage?.action === 'addAdmin') {
          const conversationExists = this.allConversationList.some(conversation => conversation.conversationId === parsedMessage.conversationId);
          if (parsedMessage.conversationId === this.selectedConversationId) {
            this.conversationMetaData.members = this.conversationMetaData?.members?.map(member => {
              return {
                ...member,
                isAdmin: member.userId === parsedMessage.memberId ? true : member.isAdmin,
              };
            });
          }
          if (conversationExists) {
            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    lastMessageDetails: {
                      ...conversation.lastMessageDetails,
                      body: `${parsedMessage?.initiatorId === this.userMetaData.userId ? 'you' : parsedMessage.memberName} made ${parsedMessage?.memberName} an admin`,
                      sentAt: parsedMessage?.sentAt || Date.now(),
                      action: parsedMessage?.action,
                      userName: parsedMessage?.userName,
                      userProfileImageUrl: parsedMessage?.userProfileImageUrl,
                      initiatorId: parsedMessage?.initiatorId,
                      initiatorName: parsedMessage?.initiatorName,
                      memberName: parsedMessage?.memberName,
                    },
                  };
                }
                return conversation;
              }),
            );
          } else if (!conversationExists) {
            const newConversation = {
              conversationId: parsedMessage.conversationId,
              lastMessageDetails: {
                body: `${parsedMessage?.initiatorId === this.userMetaData.userId ? 'you' : parsedMessage.memberName} made ${parsedMessage?.memberName} an admin`,
                sentAt: parsedMessage?.sentAt || Date.now(),
                action: parsedMessage?.action,
                userName: parsedMessage?.userName,
                userProfileImageUrl: parsedMessage?.userProfileImageUrl,
                initiatorId: parsedMessage?.initiatorId,
                initiatorName: parsedMessage?.initiatorName,
                memberName: parsedMessage?.memberName,
              },
              isGroup: true,
              conversationTitle: parsedMessage?.conversationTitle,
              conversationImageUrl: parsedMessage?.conversationImageUrl,
            };
            // Add the new conversation to the list and sort
            this.allConversationList = this.sortConversationsByLatestMessage([newConversation, ...this.allConversationList]);
          }
        }
        if (parsedMessage?.action === 'removeAdmin') {
          const conversationExists = this.allConversationList.some(conversation => conversation.conversationId === parsedMessage.conversationId);
          if (parsedMessage.conversationId === this.selectedConversationId) {
            this.conversationMetaData.members = this.conversationMetaData?.members?.map(member => {
              return {
                ...member,
                isAdmin: member.userId === parsedMessage.memberId ? false : member.isAdmin,
              };
            });
          }
          if (conversationExists) {
            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    lastMessageDetails: {
                      ...conversation.lastMessageDetails,
                      body: `${parsedMessage?.initiatorId === this.userMetaData.userId ? 'you' : parsedMessage.memberName} removed ${parsedMessage?.memberName} as an admin`,
                      sentAt: parsedMessage?.sentAt || Date.now(),
                      action: parsedMessage?.action,
                      userName: parsedMessage?.userName,
                      userProfileImageUrl: parsedMessage?.userProfileImageUrl,
                      initiatorId: parsedMessage?.initiatorId,
                      initiatorName: parsedMessage?.initiatorName,
                      memberName: parsedMessage?.memberName,
                    },
                  };
                }
                return conversation;
              }),
            );
          } else if (!conversationExists) {
            const newConversation = {
              conversationId: parsedMessage.conversationId,
              lastMessageDetails: {
                body: `${parsedMessage?.initiatorId === this.userMetaData.userId ? 'you' : parsedMessage.memberName} removed ${parsedMessage?.memberName} as an admin`,
                sentAt: parsedMessage?.sentAt || Date.now(),
                action: parsedMessage?.action,
                userName: parsedMessage?.userName,
                userProfileImageUrl: parsedMessage?.userProfileImageUrl,
                initiatorId: parsedMessage?.initiatorId,
                initiatorName: parsedMessage?.initiatorName,
                memberName: parsedMessage?.memberName,
              },
              isGroup: true,
              conversationTitle: parsedMessage?.conversationTitle,
              conversationImageUrl: parsedMessage?.conversationImageUrl,
            };
            // Add the new conversation to the list and sort
            this.allConversationList = this.sortConversationsByLatestMessage([newConversation, ...this.allConversationList]);
          }
        }
        if (parsedMessage?.action == 'chatMessageSent' || parsedMessage?.action == 'forward') {

          const conversationExists = this.allConversationList.some(conversation => conversation.conversationId === parsedMessage.conversationId);

          const isGroup = !parsedMessage.privateOneToOne;
          if (!conversationExists) {
            // Create a new conversation object from the message data
            const newConversation = {
              conversationId: parsedMessage.conversationId,
              lastMessageDetails: {
                body: parsedMessage?.body,
                updatedAt: parsedMessage?.sentAt || Date.now(),
                userName: parsedMessage?.senderName,
                userProfileImageUrl: parsedMessage?.senderProfileImageUrl,
                action: parsedMessage?.action,
                isDeliveredToAllMembers: false,
                isReadByAllMembers: false,
                isPendingAllMembers: false,
                senderId: parsedMessage?.senderId,
                sentAt: parsedMessage?.sentAt || 0,
                members: parsedMessage?.members || [],
                senderName: parsedMessage?.senderName,
                messageId: parsedMessage?.messageId,
              },

              isGroup: isGroup,
              conversationTitle: parsedMessage?.conversationTitle,
              conversationImageUrl: parsedMessage?.conversationImageUrl,

              opponentDetails: !isGroup
                ? {
                    // Use the sender's details only if they're not the current user
                    userName: parsedMessage?.senderId !== this.userMetaData?.userId ? parsedMessage?.senderName : this.conversationMetaData?.opponentDetails?.userName,
                    userProfileImageUrl:
                      parsedMessage?.senderId !== this.userMetaData?.userId
                        ? parsedMessage?.senderProfileImageUrl
                        : this.conversationMetaData?.opponentDetails?.userProfileImageUrl,
                    userId: parsedMessage?.senderId !== this.userMetaData?.userId ? parsedMessage?.senderId : this.conversationMetaData?.opponentDetails?.userId,
                  }
                : null,
            };
            // Add the new conversation to the list and sort
            this.allConversationList = this.sortConversationsByLatestMessage([newConversation, ...this.allConversationList]);
          } else {
            // Update existing conversation
            this.allConversationList = this.sortConversationsByLatestMessage(
              this.allConversationList.map(conversation => {
                if (conversation.conversationId === parsedMessage.conversationId) {
                  return {
                    ...conversation,
                    lastMessageDetails: {
                      ...conversation.lastMessageDetails,
                      body: parsedMessage.body,
                      updatedAt: parsedMessage.sentAt || Date.now(),
                      attachments: parsedMessage?.attachments || [],
                      action: parsedMessage?.action,
                      isDeliveredToAllMembers: false,
                      isReadByAllMembers: false,
                      isPendingAllMembers: false,
                      senderId: parsedMessage.senderId,
                      sentAt: parsedMessage?.sentAt || 0,
                      members: parsedMessage?.members || [],
                      senderName: parsedMessage?.senderName,
                      messageId: parsedMessage?.messageId,
                      opponentDetails: conversation.opponentDetails,
                    },
                    isGroup: conversation.isGroup,
                    conversationTitle: conversation.conversationTitle,
                    conversationImageUrl: conversation.conversationImageUrl,
                    opponentDetails: conversation.opponentDetails,
                  };
                }
                return conversation;
              }),
            );
          }

          // Re-sort the conversations after update
          this.allConversationList = this.sortConversationsByLatestMessage(this.allConversationList);

          if (parsedMessage.conversationId === this.selectedConversationId) {
            if (parsedMessage.senderId !== this.userMetaData?.userId) {
              const currentCount = this.newMessageNotification?.count || 0;
              const newCount = currentCount + 1;
              this.newMessageNotification = {
                messageId: parsedMessage.messageId,
                count: newCount,
                conversationId: parsedMessage.conversationId,
              };
            }
          }
          
          // Add message to current conversation if it's for the selected conversation
          if (parsedMessage.conversationId === this.selectedConversationId) {
            const messageAdded = this.addMessageToCurrentConversation(parsedMessage);
            if (messageAdded) {
              console.log(`✅ Real-time chatMessageSent/forward added: ${parsedMessage.messageId} to conversation: ${parsedMessage.conversationId}`);
            }
          }
          
          // Call getUserConversationDetails after chatMessageSent
          await this.getUserConversationDetails(parsedMessage.conversationId);
          
          // Force re-render of header buttons if this is the current conversation
          if (parsedMessage.conversationId === this.selectedConversationId) {
            // Trigger a re-render by updating the conversation metadata
            this.conversationMetaData = { ...this.conversationMetaData };
          }
        }

        // Handle incoming messages (not from current user)
        if (
          parsedMessage?.senderId !== this.userMetaData?.userId &&
          parsedMessage?.action !== 'typingEvent' &&
          parsedMessage?.action !== 'messageRead' &&
          parsedMessage?.action !== 'multipleMessagesRead' &&
          parsedMessage?.action !== 'messagesDeleteForAll' &&
          parsedMessage?.action !== 'messagesDeleteLocal' &&
          parsedMessage?.action !== 'messageDelivered' &&
          parsedMessage?.action !== 'conversationCreated' &&
          parsedMessage?.action !== 'chatMessageSent' && // Exclude chatMessageSent as it's handled above
          parsedMessage?.action !== 'forward' && // Exclude forward as it's handled above
          !parsedMessage?.customType // Exclude messages with customType as they are handled separately
        ) {
          // First, update unread count for the conversation that received the message
          this.allConversationList = this.allConversationList.map(conversation => {
            if (conversation.conversationId === parsedMessage?.conversationId) {
              const currentUnreadCount = parseInt(conversation.unreadMessagesCount) || 0;
              const newUnreadCount = currentUnreadCount + 1;
              conversation.unreadMessagesCount = newUnreadCount;
              this.unreadMessageCount = newUnreadCount;
              console.log(`📬 Unread count updated for conversation: ${parsedMessage.conversationId} to ${newUnreadCount}`);
            }
            return conversation;
          });

          // Then, add message to current conversation if it's for the selected conversation
          if (parsedMessage.conversationId === this.selectedConversationId) {
            // Use the new method for proper message handling with deduplication
            const messageAdded = this.addMessageToCurrentConversation(parsedMessage);
            if (messageAdded) {
              console.log(`✅ Real-time message added: ${parsedMessage.messageId} to conversation: ${parsedMessage.conversationId}`);
            } else {
              console.log(`⚠️ Message already exists or not for current conversation: ${parsedMessage.messageId}`);
            }
          }

          // Re-sort conversations after updating unread count
          this.allConversationList = this.sortConversationsByLatestMessage(this.allConversationList);

          // Emit event with updated conversation data to ensure sidebar gets the latest state
          this.unreadMessageCountUpdated.emit({
            detail: {
              conversationId: parsedMessage.conversationId,
              count: 1,
              updatedConversation: this.allConversationList.find(conv => conv.conversationId === parsedMessage.conversationId),
              allConversations: this.allConversationList
            },
          });

          try {
            await ChatSDK.getInstance().message.putIndicateDelivered({ conversationId: parsedMessage?.conversationId, messageId: parsedMessage?.messageId });
          } catch (error) {
            console.error(error, 'putIndicateDelivered request error');
          }
        }

        // Handle message delivery status updates
        if (parsedMessage?.action === 'messageDelivered' || parsedMessage?.action === 'messageRead') {
          const isRead = parsedMessage?.action === 'messageRead';
          const isDelivered = parsedMessage?.action === 'messageDelivered';

          // Update conversation list with new message status
          this.allConversationList = this.allConversationList.map(conversation => {
            if (conversation.conversationId === parsedMessage.conversationId) {
              // Only update if the status has actually changed
              const currentReadStatus = conversation.lastMessageDetails?.readByAll;
              const currentDeliveredStatus = conversation.lastMessageDetails?.deliveredToAll;

              if (currentReadStatus !== isRead || currentDeliveredStatus !== isDelivered) {
                // Emit event when status changes
                this.messageReadStatusUpdated.emit({
                  detail: {
                    conversationId: parsedMessage?.conversationId,
                    isRead,
                    isDelivered,
                    messageId: parsedMessage?.messageId,
                  },
                  bubbles: true,
                  composed: true,
                });

                return {
                  ...conversation,
                  lastMessageDetails: {
                    ...conversation.lastMessageDetails,
                    readByAll: isRead,
                    deliveredToAll: isDelivered,
                    senderId: conversation.lastMessageDetails?.senderId,
                  },
                };
              }
            }
            return conversation;
          });
        }

        if (parsedMessage?.action == 'messageRead' && parsedMessage.senderId != this.userMetaData?.userId) {
          // Update single message read status
          this.allMessages = this.allMessages?.map(message => (message?.messageId === parsedMessage?.messageId ? { ...message, readByAll: true } : message));

          // Emit event for message read status update
          this.messageReadStatusUpdated.emit({
            detail: {
              conversationId: parsedMessage.conversationId,
              isRead: true,
              isDelivered: true,
              messageId: parsedMessage.messageId,
            },
          });
        }

        // Update unread count if message is not in current conversation
        if ((parsedMessage?.action == 'chatMessageSent' || parsedMessage?.action == 'forward') && parsedMessage.senderId != this.userMetaData?.userId) {
          const totalUnreadConversation = this.allConversationList?.filter(conversation => conversation?.unreadMessagesCount > 0);
          if (totalUnreadConversation?.length > 0) {
            unreadCountStore.updateTotalUnreadCount(totalUnreadConversation?.length);
          }
          
          // Call getUserConversationDetails after chatMessageSent
          await this.getUserConversationDetails(parsedMessage.conversationId);
          
          // Force re-render of header buttons if this is the current conversation
          if (parsedMessage.conversationId === this.selectedConversationId) {
            // Trigger a re-render by updating the conversation metadata
            this.conversationMetaData = { ...this.conversationMetaData };
          }
        }

        // Update total unread count store after any message action
        const totalUnreadConversations = this.allConversationList?.filter(conversation => conversation?.unreadMessagesCount > 0);
        unreadCountStore.updateTotalUnreadCount(totalUnreadConversations?.length || 0);

        // Add this to your existing MQTT message handler in subscribeToMQTT()
        if (topic.includes('/members')) {
          try {
            const memberUpdate = JSON.parse(message.toString());
            if (memberUpdate.type === 'member_removed' && memberUpdate.conversationId === this.selectedConversationId) {
              // Update conversation metadata and group members store
              this.conversationMetaData = {
                ...this.conversationMetaData,
                members: memberUpdate.updatedMembers,
              };

              groupMembersStore.initializeMembers(memberUpdate.updatedMembers, memberUpdate.conversationId);

              // Show toast notification for other members
              if (memberUpdate.removedByUserId !== this.isometrikUserId) {
                showToast({
                  message: 'A member has been removed from the group',
                  type: 'info',
                  duration: 3000,
                  position: 'bottom-left',
                });
              }
            }
          } catch (error) {
            console.error('Error handling member update message:', error);
          }
        }
      });
      this.isMessageListenerAttached = true;
    }
  }
  ///

  private async handleForwardMessage(parsedMessage: any) {
    try {
      // Check if the conversation already exists
      const conversationExists = this.allConversationList.some(conversation => conversation.conversationId === parsedMessage.conversationId);

      if (!conversationExists) {
        // Get conversation details first
        const conversationDetails = await this.getUserConversationDetails(parsedMessage.conversationId);
        // Use the conversation details to create the new conversation object
        const newConversation = {
          conversationId: parsedMessage.conversationId,
          lastMessageDetails: {
            body: parsedMessage.body,
            updatedAt: parsedMessage.updatedAt || Date.now(),
            // @ts-ignore
            userName: conversationDetails?.opponentDetails?.userName,
            // @ts-ignore
            userProfileImageUrl: conversationDetails?.opponentDetails?.userProfileImageUrl,
          },
          unreadMessagesCount: 0,
          // Add details from the API response
        };

        // Add the new conversation to the list and sort
        this.allConversationList = this.sortConversationsByLatestMessage([newConversation, ...this.allConversationList]);
        await this.getAllAttachments(newConversation.conversationId);
      } else {
        // Update existing conversation
        this.allConversationList = this.sortConversationsByLatestMessage(
          this.allConversationList.map(conversation => {
            if (conversation.conversationId === parsedMessage.conversationId) {
              return {
                ...conversation,
                lastMessageDetails: {
                  ...conversation.lastMessageDetails,
                  body: parsedMessage.body,
                  updatedAt: parsedMessage.updatedAt || Date.now(),
                },
                isGroup: conversation.isGroup,
                conversationTitle: conversation.conversationTitle,
                conversationImageUrl: conversation.conversationImageUrl,
                opponentDetails: conversation.opponentDetails,
              };
            }
            return conversation;
          }),
        );
      }

      this.unreadMessageCountUpdated.emit({
        detail: {
          conversationId: parsedMessage.conversationId,
          count: 1,
        },
      });
    } catch (error) {
      console.error('Error handling forward message:', error);
    }
  }

  @Listen('remove-member-clicked')
  async handleRemoveMemberClicked(event) {
    const isGroupcast = event.detail.isGroupcast;
    const memberToRemove = event.detail.userId;
    const originalMembers = this.conversationMetaData?.members || [];
    const groupcastId = event.detail.conversationId
    

    try {
      if(isGroupcast) {
        removeGroupcastMember(groupcastId, memberToRemove)
      } else {
        await removeConversationMember(this.selectedConversationId, memberToRemove);

        const updatedMembers = originalMembers.filter(member => member.userId !== memberToRemove);
  
        this.conversationMetaData = {
          ...this.conversationMetaData,
          members: updatedMembers,
        };
  
        groupMembersStore.initializeMembers(updatedMembers, this.selectedConversationId);
  
      }
     
      showToast({
        message: 'Member removed successfully',
        type: 'success',
        duration: 3000,
        position: 'bottom-left',
      });
    } catch (error) {
      console.error('Error removing member:', error);
      showToast({
        message: 'Failed to remove member',
        type: 'error',
        duration: 3000,
        position: 'bottom-left',
      });
    } finally {
      drawerDialogService.closeDialog('confirm-dialog');
    }
  }

  @Listen('profile-clicked')
  async onProfileClick(event) {
    if (event.type === 'profile-clicked') {
      this.activeTab = 'Profile';
    }
  }

  @Listen('members-list-scrolled-to-bottom')
  async handleMembersListScrolledToBottom(event) {
    try {
      this.hasMoreEligibleMembers = true;
      this.membersListSkip += 20;
      const newMembers = await getConversationEligibleMembers(this.selectedConversationId, null, 20, this.membersListSkip);

      if (newMembers.conversationEligibleMembers.length < 20) {
        this.hasMoreEligibleMembers = false;
      }
      this.eligibleMembers = [...this.eligibleMembers, ...newMembers.conversationEligibleMembers];

      const membersList = event.target;
      membersList.isLoading = false;
    } catch (error) {
      console.error('Error loading more members:', error);
      this.hasMoreEligibleMembers = false;
      const membersList = event.target;
      membersList.isLoading = false;
    }
  }
  @Listen('close-right-Sidebar')
  async handleContactInfo(event: CustomEvent) {
    const { type } = event.detail;
    if (type === 'close-right-Sidebar') {
      this.showRightSideBar = false;
      this.isOpenSearchBar = false;
      this.isContactInfoOpen = false;
      this.isProfileInfoOpen = false;
      this.searchedMessageDetails = [];
    }
  }
  @Listen('close-contact-info')
  async handleProfileInfo(event: CustomEvent) {
    const { type } = event.detail;
    if (type === 'close-contact-info') {
      this.showRightSideBar = true;
      this.isContactInfoOpen = true;
      this.isProfileInfoOpen = false;
      this.searchedMessageDetails = [];
    }
  }

  

  @Listen('open-right-Sidebar')
  async handleOpen(event: CustomEvent) {
    const { type, renderComponent, userId, userName } = event.detail;
    const {isGroupcast, groupcastId} = await  getGroupcastUrlQuery()
    if (type === 'open-right-Sidebar') {
      this.showRightSideBar = true;
      if (renderComponent === 'message-search-container') {
        this.isOpenSearchBar = true;
        this.isContactInfoOpen = false;
        this.isProfileInfoOpen = false;
      } else if (renderComponent === 'contact-info') {
        this.isContactInfoOpen = true;
        this.getAllLinksCount(this.selectedConversationId);
        if(isGroupcast) {
          this.getGroupcastMembers(groupcastId)
        }
        this.isOpenSearchBar = false;
      } else if (renderComponent === 'profile-info') {
        this.isContactInfoOpen = false;
        this.isProfileInfoOpen = true;
        this.isOpenSearchBar = false;
        this.getConversationId(userId, userName);
      }
    }
  }

  async getConversationId(selectedContactId, selectedContactName) {
    try {
      const paramsForCreateConversation = {
        typingEvents: true,
        readEvents: true,
        pushNotifications: true,
        members: [selectedContactId],
        isGroup: false,
        conversationType: 0,
        searchableTags: [selectedContactName],
      };
      const res = await ChatSDK.getInstance().Conversation.postConversation(paramsForCreateConversation);

      if (res.conversationId) {
        this.conversationIdFromContactinfo = res.conversationId;
        this.getUserConversationDetails(res.conversationId);
        this.getAllAttachments(res.conversationId, 'Profile-info');
        this.getMessages(0, res.conversationId);
      }
    } catch (error) {
      console.error('Error creating conversation:', error);
    }
  }

  @Listen('get-links')
  async handleGetLinks(event: CustomEvent) {
    const { conversationId } = event.detail;
    this.getAllLinks(conversationId);
  }

  /// for get user details start
  getUserDetails = async () => {
    try {
      const res = await ChatSDK.getInstance().user.getUserDetails();
      const userDetails = {
        //@ts-ignore
        userId: res?.userId || '',
        userIdentifier: res?.userIdentifier || '',
        //@ts-ignore
        firstName: res?.metaData?.firstName || '',
        //@ts-ignore
        lastName: res?.metaData?.lastName || '',
        updatedAt: res?.updatedAt || '',
        userName: res?.userName || '',
        online: res?.online || '',
        userProfileImageUrl: res?.userProfileImageUrl || '',
        //@ts-ignore
        profilePic: res?.metaData?.profilePic || '',
      };
      this.userMetaData = userDetails;
    } catch (error) {
      console.error(error, 'getUserDetails fetching error');
    }
  };
  /// for get user details end

  //get all Conversation
  getConversations = async (skip: number = 0, searchTag: string | null = null, showLoader: boolean = false) => {
   
    
    this.hasMoreConversations = true;
    const queryParamsGetConversations = {
      limit: 20,
      skip: skip,
      includeMembers: true,
    };
    if (searchTag) {
      queryParamsGetConversations['searchTag'] = searchTag;
    }
    
    if (showLoader) {
      this.isLoadingConversationList = true;
    }
    try {
      const res = await ChatSDK.getInstance().Conversation.getConversations(queryParamsGetConversations);
      
      const uniqueConversations = res.conversations.filter(newConv => !this.allConversationList.some(existingConv => existingConv.conversationId === newConv.conversationId));
      
      this.allConversationList = [...this.allConversationList, ...uniqueConversations];
      
      // Smart preloading logic for infinite scroll with filtering
      if (this.isPreloadingForFilter) {
        await this.checkAndPreloadForFilter();
      }
      return { success: true, hasMoreData: res.conversations.length === 20 };
    } catch (error) {
      console.error('getConversations fetching error', error);
      if (error?.status === 404 || error?.statusCode === 404) {
        this.hasMoreConversations = false;
        this.isPreloadingForFilter = false;
        return { success: false, hasMoreData: false, is404: true };
      }
      return { success: false, hasMoreData: false };
    } finally {
      this.isLoadingConversationList = false;
    }
  };

  // Smart preloading method to ensure enough conversations for infinite scroll
  checkAndPreloadForFilter = async () => {
    if (this.lastActiveTab === 'all') {
      // For "all" tab, we don't need special preloading
      this.isPreloadingForFilter = false;
      return;
    }

    // Count conversations that match the current filter
    const filteredCount = this.allConversationList.filter(conversation => {
      if (this.lastActiveTab === 'buying') {
        return this.leofferAccountId === conversation?.metaData?.buyerAccountId;
      } else if (this.lastActiveTab === 'selling') {
        return this.leofferAccountId === conversation?.metaData?.sellerAccountId;
      }
      return true;
    }).length;


    // If we don't have enough filtered conversations, keep loading more
    if (filteredCount < this.minConversationsForScroll && !this.isPreloadingForFilter && !this.hasReachedEndOfConversations) {
      this.isPreloadingForFilter = true;
      
      // Load more conversations until we have enough or reach a reasonable limit
      const maxPreloadAttempts = 10; // Prevent infinite loading
      let attempts = 0;
      
      while (filteredCount < this.minConversationsForScroll && attempts < maxPreloadAttempts && !this.hasReachedEndOfConversations) {
        attempts++;
        this.conversationCountSkip += 20;
        
        // Call getConversations and check the response
        const result = await this.getConversations(this.conversationCountSkip);
        
        // If we get a 404, stop preloading immediately
        if (result && result.is404) {
          this.isPreloadingForFilter = false;
          this.hasReachedEndOfConversations = true;
          break;
        }
        
        // If the request failed for other reasons, stop preloading
        if (result && !result.success) {
          this.isPreloadingForFilter = false;
          break;
        }
        
        // Recalculate filtered count
        const newFilteredCount = this.allConversationList.filter(conversation => {
          if (this.lastActiveTab === 'buying') {
            return this.leofferAccountId === conversation?.metaData?.buyerAccountId;
          } else if (this.lastActiveTab === 'selling') {
            return this.leofferAccountId === conversation?.metaData?.sellerAccountId;
          }
          return true;
        }).length;
        
        if (newFilteredCount >= this.minConversationsForScroll) {
          break;
        }
        
        // If we didn't get any new data, stop preloading
        if (result && !result.hasMoreData) {
          break;
        }
      }
      
      this.isPreloadingForFilter = false;
    }
  };

  // Method to get filtered conversations count for UI feedback
  getFilteredConversationsCount = (activeTab: string) => {
    if (activeTab === 'all') {
      return this.allConversationList.length;
    }
    
    return this.allConversationList.filter(conversation => {
      if (activeTab === 'buying') {
        return this.leofferAccountId === conversation?.metaData?.buyerAccountId;
      } else if (activeTab === 'selling') {
        return this.leofferAccountId === conversation?.metaData?.sellerAccountId;
      }
      return true;
    }).length;
  };
  //get all Conversation end

  getGroupCastConversationDetails = async (groupcastId?: string) => {
    try {
      const res = await getGroupcast({ ids: groupcastId });
      this.conversationMetaData = res?.groupcasts?.[0];
    } catch (error) {
      console.error(error, 'GroupCast details fetching error');
    }
  };

  getUserConversationDetails = async (conversationId?: string) => {
    const queryParamsGetConversationDetails = {
      conversationId: conversationId || this.selectedConversationId,
      includeMembers: true,
    };
    try {
      const res = await ChatSDK.getInstance().Conversation.getConversationDetails(queryParamsGetConversationDetails, conversationId || this.selectedConversationId);
      
      // If conversationId is provided, check if it matches the currently selected conversation
      if (conversationId) {
        if (conversationId === this.selectedConversationId) {
          // Update the main conversation metadata for the currently selected conversation
         
          this.conversationMetaData = res.conversationDetails;
        } else {
          // Update the select conversation metadata for other conversations
          this.selctConversationMetaData = res.conversationDetails;
        }
      } else {
        // No conversationId provided, update the main conversation metadata
        this.conversationMetaData = res.conversationDetails;
      }
      return res.conversationDetails;
    } catch (error) {
      console.error(error, 'getConversationDetails fetching error');
    }
  };

  /// for get all messages start
  getMessages = async (skip: number, conversationId?: string) => {
    this.isMessagesLoading = true;
    this.isScrollToTop = true;
    this.isMessageLimitEnd = false;
    try {
      const res = await ChatSDK.getInstance().message.getMessages({ conversationId: conversationId || this.selectedConversationId, limit: 20, skip: skip });
      if (skip == 0) {
        if (conversationId) {
          this.selectConversationMessages = [...res.messages.reverse()];
        } else {
          this.allMessages = [...res.messages.reverse()];
        }
      } else {
        this.allMessages = [...res.messages.reverse(), ...this.allMessages];
      }

      let messagesWithAttachments = 0;
      this.allMessages.forEach(message => {
        if (message.hasOwnProperty('attachments') && message.attachments !== null) {
          messagesWithAttachments++;
        }
      });
    } catch (error) {
      if (error?.status === 404 || error?.statusCode === 404) {
        this.isMessageLimitEnd = true;
      }
    } finally {
      this.isMessagesLoading = false;
    }
  };
  ///for get all messages end

  //for get unread Messages Count
  getMessageUnreadCount = async () => {
    try {
      const res = await ChatSDK.getInstance().message.getUnreadCount({ converationId: this.selectedConversationId });
      this.unreadMessageCountFromApi = res.count; // Update state with unread count
    } catch (error) {
      console.error('Error while getting unread count', error);
    }
  };
  // for get unread Messages Count END

  getMessagesByQuery = async (searchText: string) => {
    const queryParamForMessagesSearch = {
      conversationId: this.selectedConversationId,
      searchTag: searchText,
      skip: 0,
      limit: 20,
    };
    this.isLoadingMessage = true;
    try {
      const res = await ChatSDK.getInstance().message.getMessages(queryParamForMessagesSearch);
      this.searchedMessageDetails = res.messages;
    } catch (error) {
      this.searchedMessageDetails = [];
      console.error('Error while searching messages in a chat', error);
    } finally {
      this.isLoadingMessage = false;
    }
  };

  getAllLinks = async selectedConversationIDForAttachments => {
    const queryParamForGetAllAttachments = {
      conversationId: selectedConversationIDForAttachments,
      customTypes: 'AttachmentMessage:Link',
    };
    try {
      const res = await ChatSDK.getInstance().message.getMessages(queryParamForGetAllAttachments);
      this.allLinks = [...res.messages];
    } catch (error) {
      console.error('Error while fetching all the links for a particular conversation', error);
      this.allLinks = [];
    }
  };


  getGroupcastMembers = async (groupcastId) => {
    try {
      const res = await getGroupcastMembers({ groupcastId });
      this.groupcastMembers = res?.members;
    } catch (error) {
      console.error('Error while fetching all the links for a particular conversation', error);
      this.groupcastMembers = [];
    }
  }

  getAllLinksCount = async selectedConversationIDForAttachments => {
    const queryParamForGetAllAttachments = {
      conversationId: selectedConversationIDForAttachments,
      customTypes: 'AttachmentMessage:Link,AttachmentMessage:Multiple,AttachmentMessage:Image,AttachmentMessage:Video,AttachmentMessage:Audio,AttachmentMessage:File',
    };
    try {
      const res = await ChatSDK.getInstance().message.getMessagesCount(queryParamForGetAllAttachments);
      this.allLinksCount = res.messagesCount;
    } catch (error) {
      console.error('Error while fetching all the links for a particular conversation', error);
      this.allLinksCount = 0;
    }
  };

  getAllAttachments = async (selectedConversationIDForAttachments: string, from?: string) => {
    const queryParamForGetAllAttachments = {
      conversationId: selectedConversationIDForAttachments,
      customTypes: 'AttachmentMessage:Media,AttachmentMessage:Multiple',
    };

    this.loadingMediaGallery = true;
    this.allAttachments = [];
    this.selectConverSationAttachments = [];

    try {
      //@ts-ignore
      const res = await ChatSDK.getInstance().message.getMessages(queryParamForGetAllAttachments);

      if (Array.isArray(res.messages)) {
        const filteredMessages = res.messages.filter(message => {
          if (!message.attachments || !Array.isArray(message.attachments)) {
            return false;
          }
          const validAttachments = message.attachments.filter(attachment => (attachment as any).mimeType && !(attachment as any).mimeType.startsWith('application'));

          return validAttachments.length > 0;
        });

        if (from === 'Profile-info') {
          this.selectConverSationAttachments = [...filteredMessages];
        } else {
          this.allAttachments = [...filteredMessages];
        }
      }
    } catch (error) {
      console.error('Error while fetching all the attachments for a particular conversation', error);
      this.allAttachments = [];
      this.selectConverSationAttachments = [];
    } finally {
      this.loadingMediaGallery = false;
    }
  };
  // for clear all messages in a conversation for self

  clearConversation = async (conversationId?: string) => {
    try {
      // Call the API to clear the conversation
      await ChatSDK.getInstance().Conversation.deleteConversationLocal({
        conversationId: conversationId || this.selectedConversationId,
      });

      // Clear messages from local state
      this.allMessages = [];

      // Update the conversation list to remove the last message
      this.allConversationList = this.allConversationList.map(conversation => {
        if (conversation.conversationId === this.selectedConversationId) {
          return {
            ...conversation,
            lastMessageDetails: {
              ...conversation.lastMessageDetails,
              body: '',
              updatedAt: Date.now(),
            },
          };
        }
        return conversation;
      });
    } catch (error) {
      console.error('Error while clearing conversation:', error);
    } finally {
      drawerDialogService.closeDialog('confirm-dialog');
    }
  };

  deleteConversation = async (conversationId: string) => {
    try {
      await ChatSDK.getInstance().Conversation.deleteConversationClear({
        conversationId: conversationId,
      });

      // Check if the deleted conversation ID is the same as the selected conversation ID
      if (this.selectedConversationId === conversationId) {
        // Remove the conversation ID from the URL
        const url = new URL(window.location.href);
        url.searchParams.delete('conversation');
        window.history.pushState({}, '', url);

        // Reset the selected conversation ID
        this.selectedConversationId = null;
        this.showSidebar = true; // Show sidebar if no conversation is selected
      }

      // Remove the conversation from the local state
      this.allConversationList = this.allConversationList.filter(conversation => conversation.conversationId !== conversationId);
    } catch (error) {
      console.error('Error while deleting the chat', error);
    } finally {
      drawerDialogService.closeDialog('confirm-dialog');
    }
  };

  blockUser = async (conversationId: string, userName: string) => {
    try {
      await ChatSDK.getInstance().user.postUserBlock({
        opponentId: conversationId,
      });
      this.isBlocked = null;
      showToast({
        message: `${userName} blocked`,
        type: 'info',
        duration: 3000,
        position: 'bottom-left',
      });
    } catch (error) {
      this.isConversationLoading = false;
      console.error(`Failed to block user with ID ${conversationId}:`, error);
    } finally {
      drawerDialogService.closeDialog('confirm-dialog');
    }
  };

  unblockUser = async (conversationId: string, userName: string) => {
    try {
      await ChatSDK.getInstance().user.postUserUnblock({
        opponentId: conversationId,
      });
      this.isBlocked = null;
      showToast({
        message: `${userName} unblocked`,
        type: 'success',
        duration: 3000,
        position: 'bottom-left',
      });
    } catch (error) {
      this.isConversationLoading = false;
      console.error(`Failed to unblock user with ID ${conversationId}:`, error);
    } finally {
      drawerDialogService.closeDialog('confirm-dialog');
    }
  };

  changeScrollToBottomState = (newState: boolean) => {
    this.isScrollToBottom = newState;
  };

  changeScrollToTopState = (newState: boolean) => {
    this.isScrollToTop = newState;
  };

  updateSkip = () => {
    if (!this.isMessageLimitEnd) {
      this.skip += 20;
    }
  };

  updateAllMessages = (newMessages: any) => {
    this.allMessages = newMessages;
  };

  refetchMessages = () => {
    this.isScrollToBottom = true;
    this.isMessageLimitEnd = false; // Changed from true to false to allow loading more messages
    this.messageAction = { action: '', initiator: false };
    this.skip = 0;
    this.allMessages = [];
    if(this.selectedConversationId){
      this.getMessages(0);
    }
    this.getMessageAction();
  };

  changeMessageSendingState = (newState: boolean) => {
    this.isMessageSending = newState;
  };

  getMessageAction = () => {
    const lastMessage = this.isProfileInfoOpen ? this.selectConversationMessages?.[this.selectConversationMessages?.length - 1] : this.allMessages?.[this.allMessages?.length - 1];
    if (lastMessage && ['userBlockConversation', 'userUnblockConversation'].includes(lastMessage?.action)) {
      this.messageAction = { action: lastMessage?.action, initiator: lastMessage?.initiatorId == this.userMetaData?.userId };
    }
  };

  deleteMessageFromSelf = async (payload: { conversationId: string; messageIds: string }) => {
    try {
      await ChatSDK.getInstance().message.deleteMessageSelf(payload);
      this.allMessages = this.allMessages.filter((message: any) => message.messageId !== payload.messageIds);
      this.allConversationList = this.sortConversationsByLatestMessage(
        this.allConversationList.map(conversation => {
          if (conversation.conversationId === payload.conversationId && conversation?.lastMessageDetails?.messageId === payload.messageIds) {
            const remainingMessages = this.allMessages.filter(msg => msg.conversationId === payload.conversationId).sort((a, b) => (a.sentAt || 0) - (b.sentAt || 0));
            const lastMessage = remainingMessages.length > 0 ? remainingMessages[remainingMessages.length - 1] : null;
            return {
              ...conversation,
              lastMessageDetails: lastMessage
                ? {
                    ...lastMessage,
                    body: lastMessage.body,
                    updatedAt: lastMessage.sentAt || Date.now(),
                    action: lastMessage.action || '',
                    senderName: lastMessage?.senderInfo?.userName,
                    senderId: lastMessage?.senderInfo?.userId,
                  }
                : null,
            };
          }
          return conversation;
        }),
      );
    } catch (error) {
      showToast({
        type: 'error',
        message: error?.message || 'Failed to delete the message',
        position: 'bottom-right',
      });
    } finally {
      drawerDialogService.closeDialog('delete-message');
    }
  };

  deleteMeassageFromEveryOne = async (payload: { conversationId: string; messageIds: string }) => {
    try {
      await ChatSDK.getInstance().message.deleteMessagesEveryone(payload);
      this.allMessages = this.allMessages.filter((message: any) => message.messageId !== payload.messageIds);
      this.allConversationList = this.sortConversationsByLatestMessage(
        this.allConversationList.map(conversation => {
          if (conversation.conversationId === payload.conversationId && conversation?.lastMessageDetails?.messageId === payload.messageIds) {
            const remainingMessages = this.allMessages.filter(msg => msg.conversationId === payload.conversationId).sort((a, b) => (a.sentAt || 0) - (b.sentAt || 0));
            const lastMessage = remainingMessages.length > 0 ? remainingMessages[remainingMessages.length - 1] : null;
            return {
              ...conversation,
              lastMessageDetails: lastMessage
                ? {
                    ...lastMessage,
                    body: lastMessage.body,
                    updatedAt: lastMessage.sentAt || Date.now(),
                    action: lastMessage.action || '',
                    senderName: lastMessage?.senderInfo?.userName,
                    senderId: lastMessage?.senderInfo?.userId,
                  }
                : null,
            };
          }
          return conversation;
        }),
      );
    } catch (error) {
      console.error(error, 'delete all error');
      showToast({
        type: 'error',
        message: error?.message || 'Failed to delete the message',
        position: 'bottom-right',
      });
    } finally {
      drawerDialogService.closeDialog('delete-message');
    }
  };

  @Watch('skip')
  handleSkipChange() {
    if (!this.isMessageLimitEnd) {
      this.getMessages(this.skip);
    }
  }

  private typingTimeout: NodeJS.Timeout | null = null;
  @Watch('isTyping')
  handleTypingChange() {
    if (this.isTyping) {
      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
      }
      this.typingTimeout = setTimeout(() => {
        this.isTyping = false;
        this.typingUserName = '';
      }, 10000);
    }
  }

  handleChatOpen = () => {
    this.isChatClosed = false;
  };
  @Watch('selectedConversationId')
  @Watch('initialConversationIdFromURL')
  async handleSelectedConversationChange(newValue: string | null) {
    if (newValue) {
      this.isConversationLoading = true;
      const url = new URL(window.location.href);
      const isGroupcast = url.searchParams.has('groupcast');

      if (isGroupcast) {
        const groupcastId = url.searchParams.get('groupcast');
        try {
          this.isScrollToBottom = true;
          this.isMessageLimitEnd = true;
          this.messageAction = { action: '', initiator: false };
          this.skip = 0;
          this.allMessages = [];
          await this.getGroupCastConversationDetails(groupcastId);
         const messages =  await getGroupcastMessage(groupcastId);

         if(messages?.messages) {
          this.allMessages = messages?.messages.reverse()
         }
        } catch (error) {
          console.error('Error while getting groupcast data', error);
        }
      } else {
        this.refetchMessages();
        this.getUserConversationDetails();
      }

      this.isConversationLoading = false;
      const selectedConversation = this.allConversationList.find(conv => conv.conversationId === newValue);
      if (selectedConversation && selectedConversation.unreadMessagesCount > 0) {
        const currentCount = unreadCountStore.getTotalUnreadCount();
        const newCount = Math.max(0, currentCount - 1);
        unreadCountStore.updateTotalUnreadCount(newCount);
      }
    } else {
      if (this.conversationDetailsInterval) {
        clearInterval(this.conversationDetailsInterval);
      }
    }
  }

  // NEW METHOD: Clear messages when switching conversations to prevent contamination
  clearCurrentConversationMessages() {
    this.allMessages = [];
    this.skip = 0;
    this.isMessageLimitEnd = false;
    this.isScrollToBottom = true;
    this.messageAction = { action: '', initiator: false };
  }

  // NEW METHOD: Handle MQTT reconnection
  async handleMqttReconnection() {
    try {
      if (this.mqttClient && this.mqttClient.client) {
        this.mqttClient.client.end();
      }
      
      // Reinitialize MQTT client
      await this.setupMqttClient();
      
      // Resubscribe to topics
      if (this.isMqttConnected) {
        this.subscribeToMQTT();
      }
    } catch (error) {
      console.error('MQTT reconnection failed:', error);
    }
  }

  // NEW METHOD: Add message with deduplication and proper validation
  addMessageToCurrentConversation(message: any) {
    // Validate message structure
    if (!message || !message.messageId || !message.conversationId) {
      console.warn('Invalid message structure:', message);
      return false;
    }

    // Check if message is for current conversation
    if (!this.selectedConversationId || message.conversationId !== this.selectedConversationId) {
      console.log(`Message not for current conversation. Current: ${this.selectedConversationId}, Message: ${message.conversationId}`);
      return false;
    }
    
    // Check for duplicates by messageId
    const messageExists = this.allMessages.some(msg => msg.messageId === message.messageId);
    if (messageExists) {
      console.log(`Message already exists: ${message.messageId}`);
      return false;
    }

    // Add message to the end of the array (newest messages at the end)
    this.allMessages = [...this.allMessages, message];
    console.log(`✅ Message added successfully: ${message.messageId}, Total messages: ${this.allMessages.length}`);
    
    return true;
  }

  // NEW METHOD: Validate message state consistency
  validateMessageState() {
    // Ensure all messages belong to the current conversation
    if (this.selectedConversationId && this.allMessages.length > 0) {
      const invalidMessages = this.allMessages.filter(msg => msg.conversationId !== this.selectedConversationId);
      if (invalidMessages.length > 0) {
        console.warn('Found messages from different conversation, clearing invalid messages');
        this.allMessages = this.allMessages.filter(msg => msg.conversationId === this.selectedConversationId);
      }
    }
  }

  @Watch('allMessages')
  @Watch('selectConversationMessages')
  async handlemessageAction() {
    // Validate message state consistency
    this.validateMessageState();
    this.getMessageAction();
  }

  handleSearchResultClick = async (messageId: string) => {
    this.highlightedMessageId = messageId;
    const messageExists = this.allMessages.some(message => message.messageId === messageId);
    if (!messageExists) {
      while (!this.allMessages.some(message => message.messageId === messageId)) {
        await this.getMessages(this.skip);
        this.skip += 20;
      }
    }

    // Scroll to the message once it is loaded
    const chatBody = document.querySelector('web-chat-body');
    if (chatBody) {
      // @ts-ignore
      chatBody.scrollToMessage(messageId);
    }
  };

  @Listen('groupExited')
  handleGroupExited(event: CustomEvent) {
    const { conversationId } = event.detail;

    // Add the group ID to the set of exited groups
    this.exitedGroupIds.add(conversationId);
  }

  @Listen('tagUserClick')
  handleTaguserClick(event: CustomEvent) {
    const { userId, userName } = event.detail;
    if (userId && userName) {
      this.createConversation(userId, userName);
    }
  }
  async createConversation(selectedContactId: string, selectedContactName: string) {
    try {
      const paramsForCreateConversation = {
        typingEvents: true,
        readEvents: true,
        pushNotifications: true,
        members: [selectedContactId],
        isGroup: false,
        conversationType: 0,
        searchableTags: [selectedContactName],
      };
      const res = await ChatSDK.getInstance().Conversation.postConversation(paramsForCreateConversation);

      if (res.conversationId) {
        this.handleChatSelect(res.conversationId);
      }
    } catch (error) {
      console.error('Error creating conversation:', error);
    }
  }
  @Listen('contact-action', { target: 'body' })
  handleContactAction(event: CustomEvent) {
    const action = event.detail.action;

    switch (action) {
      case 'exit-group':
        break;
      case 'block-contact':
        this.blockUser(event.detail.oppenentId, event.detail.userName);
        break;
      case 'unblock-contact':
        this.unblockUser(event.detail.oppenentId, event.detail.userName);
        break;
      case 'delete-chat':
        this.deleteConversation(event.detail.conversationId);
        break;
      case 'clear-chat':
        // Call clearConversation with the selected conversation ID
        this.clearConversation(event.detail.conversationId);
        break;
    }
  }

  @Listen('chat-tile-list-scrolled-to-bottom')
  async handleChatTileScrolledToBottom() {
    
    // Don't make more requests if we've reached the end
    if (this.hasReachedEndOfConversations) {
      return;
    }
    
    this.conversationCountSkip += 20;
    
    if (this.hasMoreConversations) {
      const result = await this.getConversations(this.conversationCountSkip);
    
      // If we get a 404, we've reached the end of available conversations
      if (result && result.is404) {
        this.hasReachedEndOfConversations = true;
      }
    } else {
      console.log('hasMoreConversations is false, skipping API call');
    }
  }


  handleCloseChat = () => {
    this.selectedConversationId = null;
    this.showSidebar = true;
    
    const url = new URL(window.location.href);
    url.searchParams.delete('conversation');
    url.searchParams.delete('groupcast');
    window.history.pushState({}, '', url.toString());
    this.activeTab = 'Chat'
    drawerDialogService.closeDialog('confirm-dialog');
  };

  // Add a method to reset notification count
  resetNewMessageNotification() {
    this.newMessageNotification = null;
  }


  @Listen('conversation-updated')
  async handleConversationUpdate(event: CustomEvent) {
    const { conversationId } = event.detail;
    try {
      // Fetch updated conversation details from server
      const response = await ChatSDK.getInstance().Conversation.getConversationDetails(conversationId, 'true');
      if (response) {
        // Update the conversation in the list
        this.allConversationList = this.allConversationList.map(conv => (conv.conversationId === conversationId ? { ...conv, ...response } : conv));

        // If this is the currently selected conversation, update conversation metadata
        if (this.selectedConversationId === conversationId) {
          this.conversationMetaData = response;
        }
      }
    } catch (error) {
      console.error('Error refreshing conversation details:', error);
    }
  }
  @Watch('conversationMetaData')
  async watchPropHandler(newValue: any) {
    if (newValue?.updateBlockStatus || (newValue?.messagingDisabled && this.isBlocked === null)) {
      await this.findBlokedUser();
    }
  }
  async findBlokedUser() {
    this.isBlocked = 'loading';
    try {
      const findRes = await ChatSDK.getInstance().user.getUserBlock({
        searchTag: this.conversationMetaData?.opponentDetails?.userName,
      });
      const users = findRes?.users || [];
      const currUser = users?.find(u => u?.userId === this.conversationMetaData?.opponentDetails?.userId);
      this.isBlocked = currUser ? true : null;
    } catch (e) {
      this.isBlocked = null;
    } finally {
      this.isConversationLoading = false;
    }
  }
  updateConversationList = (updatedList: any[]): any[] => {
    // Ensure the list is sorted
    const sortedList = this.sortConversationsByLatestMessage(updatedList);

    // Update the state and return the sorted list
    this.allConversationList = sortedList;
    return sortedList;
  };

  getGroupCastContacts = async (skip: number = 0) => {
    this.activeTab = 'GroupCast';
    if(!this.hasMoreGroupcast || this.isLoadingMoreGroupcast) return;
    this.isLoadingMoreGroupcast = true;
    try {
      const response = await getGroupcast({ skip, limit: 20 });
      if (response?.groupcasts?.length > 0) {
        this.allGroupCastContacts = skip === 0 
          ? response.groupcasts 
          : [...this.allGroupCastContacts, ...response.groupcasts];
        this.groupcastSkip = skip;
      } else {
        this.hasMoreGroupcast = false;
      }
    } catch (error) {
      console.error('Error fetching groupcast contacts:', error);
      this.hasMoreGroupcast = false;
    } finally {
      this.isLoadingMoreGroupcast = false;
    }
   
  };
  @Listen('groupcastScrolledToBottom')
  handleGroupcastScroll() {
    if (this.hasMoreGroupcast && !this.isLoadingMoreGroupcast) {
      this.getGroupCastContacts(this.groupcastSkip + 20);
    }
  }



  @Listen('send-qr-code-message')
  handleSendQrCodeMessage(event: CustomEvent) {
    const { message, conversationId } = event.detail;
    
    // Check if this is for the current conversation
    if (conversationId === this.selectedConversationId) {
      // Find the ChatFooter component and send the message
      const chatFooter = document.querySelector('chat-footer') as any;
      if (chatFooter) {
        chatFooter.messageBody = message;
        chatFooter.handleSendMessage();
      }
    } else {
      console.log('Conversation ID mismatch in WebChat:', conversationId, 'vs', this.selectedConversationId);
    }
  }

  @Listen('qr-code-message-ready')
  handleQrCodeMessageReady(event: CustomEvent) {
    const { message, conversationId } = event.detail;
    
    // Check if this is for the current conversation
    if (conversationId === this.selectedConversationId) {
      // Find the ChatFooter component and send the message
      const chatFooter = document.querySelector('chat-footer') as any;
      if (chatFooter) {
        chatFooter.messageBody = message;
        chatFooter.handleSendMessage();
      }
    } else {
      console.log('Conversation ID mismatch in WebChat qr-code-message-ready:', conversationId, 'vs', this.selectedConversationId);
    }
  }

  render() {
    return (
      <Fragment>
        {this.isLoading ? (
          <chat-loading-placeholder containerId={this.containerId} progress={this.loadingProgress} loadingStatus={this.loadingStatus} />
        ) : (
          <Fragment>
            {this.isConversationLoading ? (
              <div class="loaderoverlay">
                <spinner-loader
                  height="30px"
                  width="30px"
                  spinTime="1s"
                  spinnerPrimaryColor="var(--bg-primary-color)"
                  spinnerSecondaryColor="var(--text-primary-color)"
                  spinnerBorderWidth="2px"
                ></spinner-loader>
              </div>
            ) : null}
            <div class="isometrik-quickchat">
              <div
                class={{
                  'chat-sidebar-container': true,
                  'hidden': this.isMobileView && !this.showSidebar,
                }}
              >
                
                <div class={'sidebar-tab'}>
                  {this.activeTab === 'GroupCast' ? (
                    <group-cast isLoadingMore={this.isLoadingMoreGroupcast}
                    groupCastData={this.allGroupCastContacts} onGroupcastTileSelected={(e: CustomEvent) => this.handleChatSelect(e.detail)}></group-cast>
                  ) : this.activeTab === 'Chat' ? (
                    <chat-side-bar
                      conversationList={this.allConversationList}
                      unreadConversationsCount={this.unreadConversationsCount}
                      userMetaData={this.userMetaData}
                      onChatTileSelected={(e: CustomEvent) => this.handleChatSelect(e.detail)}
                      onDeleteConversation={(conversationId: string) => this.deleteConversation(conversationId)}
                      isTyping={this.isTyping}
                      typingUserName={this.typingUserName}
                      typingConversationId={this.typingConversationId}
                      isChatFilter={this.isChatFilter}
                      customTypes={[
                        { type: 'Test conversations', label: 'Unread' },
                        { type: 'SingleChat', label: 'Past' },
                        { type: 'Chatbot', label: 'Present' },
                      ]}
                      isAllChatButton={this.isAllChatButton}
                      filterTabsContainer={{
                        display: 'flex',
                        gap: '10px',
                        width: '100%',
                        flexWrap: 'wrap',
                        marginBottom: '10px',
                      }}
                      filterTab={{
                        padding: '10px 15px',
                        border: '1px solid var(--bg-primary-light)',
                        borderRadius: '25px',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s',
                        color: 'var(--text-tertiary-color)',
                        fontSize: '12px',
                        textTransform: 'uppercase',
                      }}
                      filterTabHover={{
                        backgroundColor: 'var(--bg-primary-light)',
                      }}
                      isSidebarHeaderLabel={this.isSidebarHeaderLabel}
                      isSidebarHeaderSearch={this.isSidebarHeaderSearch}
                      sidebarHeaderLabel={this.sidebarHeaderLabel}
                      sidebarColor={this.sidebarColor}
                      sidebarSelectedColor={this.sidebarSelectedColor}
                      hasMoreConversations={this.hasMoreConversations}
                      handleSearchData={(searchTag: string) => this.getConversations(0, searchTag, true)}
                      allMessages={this.allMessages}
                      leofferAccountId={this.leofferAccountId}
                      isPreloadingForFilter={this.isPreloadingForFilter}
                      handleBackButtonClick={this.handleBackButtonClick}
                    ></chat-side-bar>
                  ) : (
                    <profile-page
                      getUserDetails={this.getUserDetails}
                      name={this.userMetaData.userName}
                      profilePhotoUrl={this.userMetaData.userProfileImageUrl}
                      closeDrawer={() => (this.activeTab = 'Chat')}
                      toggleTheme={this.toggleTheme}
                      defaultTheme={this.defaultTheme}
                    ></profile-page>
                  )}
                </div>
              </div>

              <div
                class={{
                  'chat-body-container': true,
                  'show': this.isMobileView && this.selectedConversationId && !this.showSidebar,
                }}
              >
                {this.selectedConversationId ? (
                  <Fragment>
                    <web-chat-header
                      searchedMessageDetails={this.searchedMessageDetails}
                      onSearchResultClick={this.handleSearchResultClick}
                      headerBgColor="var(--bg-primary-color)"
                      headerLastSeenColor="var(--text-last-seen)"
                      headerSvgColor="var(--text-primary-color)"
                      headerUsernameColor="var(--text-primary-color)"
                      onCloseChat={this.handleCloseChat}
                      conversationDetails={this.conversationMetaData}
                      isTyping={this.isTyping && this.selectedConversationId === this.typingConversationId}
                      typingUserName={this.typingUserName}
                      chatBodyRef={this.chatBodyRef}
                      onTextClick={() => this.getAllAttachments(this.selectedConversationId)}
                      allAttachments={this.allAttachments}
                      lastSeen={this.conversationMetaData?.opponentDetails?.lastSeen}
                      userMetaData={this.userMetaData}
                      leofferAccountId={this.leofferAccountId}
                      selectedConversationId={this.selectedConversationId}
                      messageAction={this.messageAction}
                      eligibleMembers={this.eligibleMembers}
                      hasMoreEligibleMembers={this.hasMoreEligibleMembers}
                      typingConversationId={this.typingConversationId}
                      isBlocked={this.isBlocked}
                      onSearchInputChange={this.handleMessageSearchTextChange}
                      onBackButtonClick={this.handleCloseChat}
                      getPaymentsData={this.getPaymentsData}
                    />
                    <web-chat-body
                      ref={el => (this.chatBodyRef = el as HTMLWebChatBodyElement)}
                      allAttachments={this.allAttachments}
                      isMessagesLoading={this.isMessagesLoading}
                      updateSkip={this.updateSkip}
                      isMessageLimitEnd={this.isMessageLimitEnd}
                      allMessages={this.allMessages}
                      userMetaData={this.userMetaData}
                      skip={this.skip}
                      isScrollToBottom={this.isScrollToBottom}
                      changeScrollToBottomState={this.changeScrollToBottomState}
                      isMessageSending={this.isMessageSending}
                      isScrollToTop={this.isScrollToTop}
                      changeScrollToTopState={this.changeScrollToTopState}
                      deleteForSelf={this.deleteMessageFromSelf}
                      deleteForAll={this.deleteMeassageFromEveryOne}
                      isChatClosed={this.isChatClosed}
                      isChatMinimized={this.isChatMinimized}
                      updateAllMessages={this.updateAllMessages}
                      selectedConversationId={this.selectedConversationId}
                      highlightedMessageId={this.highlightedMessageId}
                      onMediaClick={() => this.getAllAttachments(this.selectedConversationId)}
                      onReplyMessageDetails={this.handleReplyMessage}
                      conversationList={this.allConversationList}
                      loadingMediaGallery={this.loadingMediaGallery}
                    />
                    {this.exitedGroupIds.has(this.selectedConversationId) ? (
                      <div
                        style={{
                          padding: '1rem',
                          textAlign: 'center',
                          backgroundColor: 'var(--bg-secondary-color)',
                          color: 'var(--text-primary-color)',
                          borderTop: '1px solid var(--bg-secondary-color)',
                        }}
                      >
                        You are no longer a member of this group
                      </div>
                    ) : this.isBlocked === 'loading' ? (
                                    
       <p class="blockMessageContainer">{WEB_CONTENT.PLEASE_WAIT}</p>
                    ) : this.conversationMetaData?.messagingDisabled ? (
                      <p class="blockMessageContainer">{WEB_CONTENT.BLOCK_CHAT_MESSAGE}</p>
                    ) : (
                      <chat-footer
                        userMetaData={this.userMetaData}
                        updateAllMessages={this.updateAllMessages}
                        changeMessageSendingState={this.changeMessageSendingState}
                        changeScrollToBottomState={this.changeScrollToBottomState}
                        refetchMessages={this.refetchMessages}
                        allMessages={this.allMessages}
                        selectedConversationId={this.selectedConversationId}
                        replyMessage={this.replyMessage}
                        handleremoveReplyMessage={this.handleremoveReplyMessage}
                        allConversationList={this.allConversationList}
                      />
                    )}
                  </Fragment>
                ) : (
                  <div style={{ backgroundColor: 'var(--bg-secondary-color)', color: 'var(--text-tertiary-color)' }} class="noChatSelectedPlaceholder">
                    <div innerHTML={selectChatPlaceholderSvg}></div>
                    <span>"Start a Conversation"</span>
                    <span>
                      Select a name from the list to begin chatting.
                      <br />
                      Connect easily and stay in touch!
                    </span>
                  </div>
                )}
              </div>
              {this.showRightSideBar ? (
                <div class={'chat-sidebar-right'}>
                  <web-chat-right-sidebar
                    conversationMetaData={this.isProfileInfoOpen ? this.selctConversationMetaData : this.conversationMetaData}
                    selectedConversationId={this.selectedConversationId}
                    hasMoreEligibleMembers={this.hasMoreEligibleMembers}
                    eligibleMembers={this.eligibleMembers}
                    allAttachments={this.isProfileInfoOpen ? this.selectConverSationAttachments : this.allAttachments}
                    userMetaData={this.userMetaData}
                    messageAction={this.messageAction}
                    searchedMessageDetails={this.searchedMessageDetails}
                    onSearchHandler={(text: string) => this.getMessagesByQuery(text)}
                    onSearchResultClick={this.handleSearchResultClick}
                    isContactInfoOpen={this.isContactInfoOpen}
                    isProfileInfoOpen={this.isProfileInfoOpen}
                    isOpenSearchBar={this.isOpenSearchBar}
                    chatBodyRef={this.chatBodyRef}
                    isLoadingMessage={this.isLoadingMessage}
                    conversationIdFromContactinfo={this.conversationIdFromContactinfo}
                    openOwnProfile={() => (this.activeTab = 'Profile')}
                    handleChatSelect={conversationId => this.handleChatSelect(conversationId)}
                    allLinks={this.allLinks}
                    allLinksCount={this.allLinksCount}
                    isBlocked={this.isBlocked}
                    groupcastMembers={this.groupcastMembers}
                  />
                </div>
              ) : null}
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}
